import { render } from "./UpdateEventModal.vue?vue&type=template&id=aab3c68c&scoped=true"
import script from "./UpdateEventModal.vue?vue&type=script&lang=js"
export * from "./UpdateEventModal.vue?vue&type=script&lang=js"

import "./UpdateEventModal.vue?vue&type=style&index=0&id=aab3c68c&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab3c68c"]])

export default __exports__